import Ajax from './ajax';

const Request = {
    Course: {//课程模块
        getList(data) {
            return Ajax.get('course/findCourseListById', data)
        },
        findCourseListById(data) {
            return Ajax.get('course/findCourseListById', data)
        },
        getInfo(data) {
            return Ajax.get('course/getCourseInfo', data)
        },
        taskCollect(data) {
            return Ajax.post('readWrite/collect', data)
        },
        getTaskList(data) {
            return Ajax.get('readWrite/list', data)
        },
        getReplyList(data) {
            return Ajax.get('readWrite/replyList', data)
        },
        setReply(data) {
            return Ajax.post('readWrite/reply', data)
        },
        setPraise(data) {
            return Ajax.post('readWrite/praise', data)
        },
        deleteReply(data) {
            return Ajax.post('readWrite/deleteReply', data)
        },
        getStudent(data) {
            return Ajax.get('readWrite/getStudent', data)
        },
        saveRead(data) {
            return Ajax.post('readWrite/saveRead', data)
        }

    },

    Ask: {
        //获取孩子列表
        getChild(data) {
            return Ajax.get('readWrite/getStudent', data)
        },
        //问答
        getQuestionList(data) {//获取答案
            return Ajax.get('coursequestion/list', data)
        },
        calculatedFraction(data) {//计算得分
            return Ajax.postJson('coursequestion/calculatedFraction', data)
        }
    },

    Dict: {//字典
        getType(data) {
            return new Promise((resolve) => {
                return Ajax.get('com/getDict', data).then(result => {
                    let data = {}
                    result.forEach(item => {
                        if (!data[item.type]) {
                            data[item.type] = [item]
                        } else {
                            data[item.type].push(item)
                        }
                    })
                    resolve(data)
                })
            })
        }
    },

    Wechat: {
        queryWechatInfo(data) {//获取h5 jssdk参数
            return Ajax.get('course/queryWechatInfo', data)
        }
    },
    User: {
        checkingH5User(data) {//通过code获取用户
            return Ajax.get('login/checkingH5User', data)
        }

    },
    Upload: {
        upload(data) {//上传图片
            return Ajax.post('/upload/uploadImage', data)
        }
    }
};

export default Request;
